if (!customElements.get('stringing-configurator')) {
  customElements.define('stringing-configurator', class StringingConfigurator extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.confirmed = false;
      this.dialog = this.querySelector('[data-stringing-dialog]');
      this.form = document.getElementById(this.dataset.formId) || this.parentElement.querySelector('product-form form');
      this.terms = this.querySelector('[data-stringing-terms]');
      this.addEventListener('change', () => this.invalidate());
      this.addEventListener('input', () => this.invalidate());
      this.variantSelect = this.querySelector('[data-stringing-variant]');
      this.summary = this.querySelector('[data-stringing-summary]');
      this.summaryText = this.querySelector('[data-stringing-summary-text]');
      this.price = this.querySelector('[data-stringing-price]');
      this.recommendedPanel = this.querySelector('[data-recommended-panel]');
      this.customPanel = this.querySelector('[data-custom-panel]');
      this.manualTension = this.querySelector('[data-manual-tension]');

      this.querySelectorAll('[data-stringing-open]').forEach((button) => button.addEventListener('click', () => this.open()));
      this.querySelectorAll('input[name^="ss_mode_"]').forEach((input) => input.addEventListener('change', () => this.updateMode()));
      this.querySelectorAll('input[name^="ss_tension_"]').forEach((input) => input.addEventListener('change', () => this.updateTension()));
      this.variantSelect.addEventListener('change', () => this.updatePrice());
      this.querySelector('[data-stringing-search]').addEventListener('input', (event) => this.filterStrings(event.target.value));
      this.querySelector('[data-stringing-confirm]').addEventListener('click', () => this.confirm());
      this.form?.addEventListener('submit', (event) => this.submitWithStringing(event), true);
      this.updateMode();
    }

    open() {
      if (this.dialog && !this.dialog.open && this.dialog.showModal) this.dialog.showModal();
    }

    invalidate() {
      this.confirmed = false;
      this.form?.querySelectorAll('[data-stringing-input]').forEach((input) => input.remove());
      this.summary.hidden = true;
      this.querySelector('.ss-stringing__teaser').hidden = false;
    }

    mode() {
      return this.querySelector('input[name^="ss_mode_"]:checked')?.value || 'recommended';
    }

    updateMode() {
      const recommended = this.mode() === 'recommended';
      this.recommendedPanel.hidden = !recommended;
      this.customPanel.hidden = this.mode() !== 'custom';
      const none = this.mode() === 'none';
      this.querySelectorAll('[data-service-panel]').forEach((panel) => { panel.hidden = none; });
      this.terms.disabled = none;
      this.terms.required = !none;
      this.terms.checked = false;
      if (this.mode() === 'custom' && this.variantSelect.selectedIndex < 0 && this.variantSelect.options.length) {
        this.variantSelect.options[0].selected = true;
      }
      this.updatePrice();
    }

    updateTension() {
      this.manualTension.hidden = this.querySelector('input[name^="ss_tension_"]:checked')?.value !== 'manual';
    }

    updatePrice() {
      if (this.mode() === 'none') { this.price.textContent = '€0,00'; return; }
      if (this.mode() === 'recommended') {
        this.price.textContent = '€24,90';
        return;
      }
      const option = this.variantSelect.options[this.variantSelect.selectedIndex];
      this.price.textContent = option ? `€${Number(option.dataset.price).toFixed(2).replace('.', ',')}` : '—';
    }

    filterStrings(term) {
      const query = term.trim().toLocaleLowerCase('it');
      let visible = 0;
      Array.from(this.variantSelect.options).forEach((option) => {
        const match = !query || option.textContent.toLocaleLowerCase('it').includes(query);
        option.hidden = !match;
        option.disabled = !match;
        if (match) visible += 1;
      });
      this.querySelector('[data-stringing-empty]').hidden = visible > 0;
      if (visible && (this.variantSelect.selectedOptions[0]?.disabled || !this.variantSelect.value)) {
        const first = Array.from(this.variantSelect.options).find((option) => !option.disabled);
        if (first) first.selected = true;
      }
      this.updatePrice();
    }

    addHidden(name, value) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      input.dataset.stringingInput = '';
      this.form.appendChild(input);
    }

    async submitWithStringing(event) {
      if (!this.confirmed) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.open();
        return;
      }
      const serviceInput = this.form.querySelector('[name="shopify-additional-items[0][id]"]');
      if (!serviceInput) return;
      event.preventDefault();
      event.stopImmediatePropagation();

      if (this.submitting) return;
      this.submitting = true;
      const submitter = event.submitter;
      const buttons = this.form.querySelectorAll('button[type="submit"]');
      buttons.forEach((button) => { button.disabled = true; button.classList.add('loading'); });

      const data = new FormData(this.form);
      const mainProperties = {};
      const serviceProperties = {};
      for (const [name, value] of data.entries()) {
        let match = name.match(/^properties\[(.+)\]$/);
        if (match && value) mainProperties[match[1]] = value;
        match = name.match(/^shopify-additional-items\[0\]\[properties\]\[(.+)\]$/);
        if (match && value) serviceProperties[match[1]] = value;
      }

      const cartDrawer = document.getElementById('Cart-Drawer');
      const sections = [{ id: 'Cart-Icon-Bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }];
      if (cartDrawer && !cartDrawer.hasAttribute('data-status-silence')) {
        sections.push({ id: 'Cart-Drawer', section: cartDrawer.dataset.section, selector: '#Cart-Drawer-Details' });
      }
      // Keep the racquet variant completely separate from stringing options
      // (e.g. "4 nodi" must never be interpreted as a grip/variant value).
      const mainVariantInput = this.form.querySelector('input[name="id"].product-variant-id, input[name="id"]');
      const mainVariantId = mainVariantInput?.value;
      const serviceVariantId = serviceInput.value;
      if (!mainVariantId || !/^\d+$/.test(mainVariantId)) {
        this.showError('Seleziona un manico disponibile prima di aggiungere la racchetta al carrello.');
        this.submitting = false;
        buttons.forEach((button) => { button.disabled = false; button.classList.remove('loading'); });
        return;
      }
      if (!serviceVariantId || !/^\d+$/.test(serviceVariantId)) {
        this.showError('La variante del servizio di incordatura non è valida.');
        this.submitting = false;
        buttons.forEach((button) => { button.disabled = false; button.classList.remove('loading'); });
        return;
      }

      const payload = {
        items: [
          { id: mainVariantId, quantity: Number(data.get('quantity') || 1), properties: mainProperties },
          { id: serviceVariantId, quantity: Number(data.get('quantity') || 1), properties: serviceProperties }
        ],
        sections: sections.map((section) => section.section),
        sections_url: window.location.pathname
      };

      try {
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: JSON.stringify(payload)
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Impossibile aggiungere la configurazione.');
        SectionDynamicUpdate.updateSections(sections, result.sections);
        webvista.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'stringing-configurator', productVariantId: data.get('id'), cartData: result });
        if (cartDrawer && !cartDrawer.hasAttribute('data-status-silence')) cartDrawer.show(submitter);
        else window.location = window.routes.cart_url;
      } catch (error) {
        const wrapper = document.getElementById(`Product-Form-Error-Message-${this.form.closest('product-form')?.dataset.section}`);
        if (wrapper) { wrapper.hidden = false; wrapper.textContent = error.message; }
      } finally {
        this.submitting = false;
        buttons.forEach((button) => { button.disabled = false; button.classList.remove('loading'); });
      }
    }

    showError(message) {
      const wrapper = document.getElementById(`Product-Form-Error-Message-${this.form?.closest('product-form')?.dataset.section}`);
      if (wrapper) {
        wrapper.hidden = false;
        wrapper.textContent = message;
      }
    }

    confirm() {
      if (!this.form) return;
      if (this.mode() === 'none') {
        this.form.querySelectorAll('[data-stringing-input]').forEach((input) => input.remove());
        this.addHidden('properties[Incordatura]', this.dataset.noneLabel);
        this.confirmed = true;
        this.summaryText.textContent = this.dataset.noneLabel;
        this.summary.hidden = false;
        this.querySelector('.ss-stringing__teaser').hidden = true;
        this.dialog.close();
        return;
      }
      if (!this.terms.reportValidity()) return;
      if (this.querySelector('input[name^="ss_tension_"]:checked')?.value === 'manual') {
        for (const input of this.manualTension.querySelectorAll('input')) {
          input.required = true;
          if (!input.reportValidity()) return;
        }
      }
      const recommended = this.mode() === 'recommended';
      const selected = recommended ? null : this.variantSelect.options[this.variantSelect.selectedIndex];
      if (!recommended && (!selected || selected.disabled)) {
        this.variantSelect.focus();
        return;
      }

      this.form.querySelectorAll('[data-stringing-input]').forEach((input) => input.remove());
      const variantId = recommended ? this.dataset.recommendedVariant : selected.value;
      const serviceName = recommended ? this.dataset.recommendedLabel : selected.textContent.replace(/\s+—\s+€[\d,.]+$/, '');
      const tensionChoice = this.querySelector('input[name^="ss_tension_"]:checked')?.value;
      const tension = tensionChoice === 'manual'
        ? `${this.querySelector('[data-tension-main]').value} kg verticali / ${this.querySelector('[data-tension-cross]').value} kg orizzontali`
        : this.dataset.technicianLabel;
      const properties = {
        'Configurazione': serviceName,
        'Tensione': tension,
        'Schema': this.querySelector('[data-stringing-knots]').value,
        'Pre-stretch': this.querySelector('[data-stringing-prestretch]').value,
        'Logo sulle corde': this.querySelector('[data-stringing-logo]').value,
        'Note per il tecnico': this.querySelector('[data-stringing-notes]').value.trim()
      };
      if (recommended) {
        properties['Livello'] = this.querySelector('[data-recommended-level]').value;
        properties['Stile di gioco'] = this.querySelector('[data-recommended-style]').value;
        properties['Esigenze del braccio'] = this.querySelector('[data-recommended-arm]').value;
      }

      this.addHidden('shopify-additional-items[0][id]', variantId);
      this.addHidden('shopify-additional-items[0][quantity]', '1');
      Object.entries(properties).forEach(([key, value]) => {
        if (value) this.addHidden(`shopify-additional-items[0][properties][${key}]`, value);
      });
      this.addHidden('properties[Incordatura]', serviceName);
      const termsText = this.querySelector('[data-stringing-terms-text]').textContent.trim();
      this.addHidden('properties[Condizioni incordatura]', this.dataset.acceptedLabel);
      this.addHidden('properties[_Condizioni incordatura testo]', termsText);
      this.addHidden('properties[_Condizioni incordatura versione]', '2026-09-19-v2');
      this.addHidden('properties[_Condizioni incordatura accettate il]', new Date().toISOString());
      this.confirmed = true;

      this.summaryText.textContent = `${serviceName} · ${tension} · ${properties.Schema}`;
      this.summary.hidden = false;
      this.querySelector('.ss-stringing__teaser').hidden = true;
      this.dialog.close();
    }
  });
}

